/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openquestionskinddate3Inputs */

const en_openquestionskinddate3 = /** @type {(inputs: Openquestionskinddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const pt_openquestionskinddate3 = /** @type {(inputs: Openquestionskinddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data`)
};

/**
* | output |
* | --- |
* | "Date" |
*
* @param {Openquestionskinddate3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const openquestionskinddate3 = /** @type {((inputs?: Openquestionskinddate3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openquestionskinddate3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openquestionskinddate3(inputs)
	return pt_openquestionskinddate3(inputs)
});
export { openquestionskinddate3 as "openQuestionsKindDate" }